<template>
    <span v-if="mostrarBtnAprovarReprovar">
        <b-button
            variant="primary"
            @click.stop="confirmarAprovarReprovar('A')"
            v-if="mostrarBtnAprovar"
            class="mr-2"
        >
            <span> <i class="fa fa-check-circle"></i> Aprovar </span>
        </b-button>
        <b-button variant="danger" @click.stop="abrirDetalheReprovacao()">
            <span> <i class="fa fa-times-circle"></i> Reprovar </span>
        </b-button>
        <b-modal
            id="modalDetalheReprovacao"
            v-model="mostrarModalDetalheReprovacao"
        >
            <div slot="modal-title">
                Registro de Pagamento - Detalhe da Reprovação
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label for="contato">Detalhe da Reprovação</label>
                        <b-form-textarea
                            v-model="detalheReprovacao"
                            :rows="4"
                            @input="$v.detalheReprovacao.$touch()"
                            :state="$v.detalheReprovacao.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >O detalhe da reprovação é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharDetalheReprovacao()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="danger"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarAprovarReprovar('R')"
                    class="ml-2"
                >
                    <span> <i class="fa fa-times-circle"></i> Reprovar </span>
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            mostrarModalDetalheReprovacao: false,
            detalheReprovacao: ''
        }
    },

    methods: {
        abrirDetalheReprovacao() {
            this.mostrarModalDetalheReprovacao = true
        },

        fecharDetalheReprovacao() {
            this.mostrarModalDetalheReprovacao = false
            this.detalheReprovacao = ''
        },

        confirmarAprovarReprovar(acao) {
            let acaoTitulo
            let acaoMensagem
            if (acao === 'A') {
                acaoTitulo = 'Aprovar'
                acaoMensagem = 'aprovação'
            } else {
                acaoTitulo = 'Reprovar'
                acaoMensagem = 'reprovação'
            }
            this.$swal({
                title: `${acaoTitulo} Registro de Pagamento`,
                html: `Confirma a ${acaoMensagem} do registro de pagamento?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.aprovarReprovar(acao)
                }
            })
        },

        aprovarReprovar(acao) {
            this.$store.dispatch('addRequest')
            let aprovaReprovaPagamentoDto = {
                pagamentoId: this.$route.params.pagamentoId,
                acao: acao,
                detalheReprovacao: this.detalheReprovacao
            }
            this.pagamentosServicos
                .aprovarReprovarPagamento(aprovaReprovaPagamentoDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterPagamentoAtualizado')
                            this.fecharDetalheReprovacao()
                        } else {
                            this.$toast.error(
                                'Erro ao atualizar registro de pagamento!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnAprovarReprovar() {
            return (
                (this.$temAcesso('APPSE-UABS-PAG-02') &&
                    (this.pagamento.status === pagamentoStatus.EM_ANALISE ||
                        this.pagamento.status ===
                            pagamentoStatus.REPROVADO_PELO_SETOR_FINANCEIRO)) ||
                (this.$temAcesso('APPSE-UFI-PAG-00') &&
                    this.pagamento.status ===
                        pagamentoStatus.EM_PROCESSAMENTO_PELO_SETOR_FINANCEIRO)
            )
        },

        mostrarBtnAprovar() {
            return (
                (this.$temAcesso('APPSE-UABS-PAG-02') &&
                    (this.pagamento.status === pagamentoStatus.EM_ANALISE ||
                        this.pagamento.status ===
                            pagamentoStatus.REPROVADO_PELO_SETOR_FINANCEIRO)) ||
                (!this.$temAcesso('APPSE-UFI-PAG-00') &&
                    this.pagamento.status ===
                        pagamentoStatus.EM_PROCESSAMENTO_PELO_SETOR_FINANCEIRO)
            )
        }
    },

    validations: {
        detalheReprovacao: {
            required
        }
    }
}
</script>
